import React from "react";
import "./Ecommerce.css";

function Ecommerce(){

    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="onlinestore.png" alt="Logo"/>
           Online Store Setup</h5>
          <p className="card-text">We offer complete online store setup services designed to launch your ecommerce business with ease. From product catalog structuring to user-friendly layouts, we build secure and scalable online shops using platforms like Shopify, WooCommerce, and Magento. Based in Coimbatore, our team ensures your store is optimized, mobile-ready, and ready to sell from day one.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className=" cardid card  border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
         <h5 className="card-title">
        <img src="shopcart.png" alt="Logo"/>
           Shopping Cart & Checkout Integration</h5>
          <p className="card-text">We implement seamless shopping cart and checkout systems that provide a smooth and secure buying experience. Our integration services are optimized for performance, mobile usability, and fast conversions. Whether you need single-page checkout or multi-step flows, we build ecommerce systems that help customers complete purchases effortlessly.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="payment.png" alt="Logo"/>
           Payment Gateway Integration</h5>
          <p className="card-text">Our team integrates trusted and secure payment gateways such as Razorpay, PayPal, Stripe, and UPI systems to help your business accept payments online with ease. We ensure all transactions are secure, reliable, and fully compliant with global standards. Our Coimbatore-based service is tailored for businesses looking for hassle-free and scalable payment solutions.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="product.png" alt="Logo"/>
           Product & Inventory Management</h5>
          <p className="card-text">We provide smart product and inventory management solutions that make adding, editing, and organizing your items simple and efficient. Our services include variant setup, stock level automation, and backend systems that save you time and reduce manual errors.<br/>
           Whether you have 10 products or 10,000, we design systems to manage them with ease.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle"></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="onlineorder.png" alt="Logo"/>
          Order Management System</h5>
          <p className="card-text">We offer custom-built order management systems that track, process, and update orders in real-time. From order confirmation to dispatch and delivery, our tools keep you in control.<br/>
           We help ecommerce businesses automate their order<br/> flow
            for faster fulfillment and better customer satisfaction<br/>
             — all under one dashboard.</p>
        </div>
      </div>
    </div>

      <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="mobile.png" alt="Logo"/>
          Mobile & Responsive Design</h5>
          <p className="card-text">We design ecommerce websites that are fully responsive and optimized for all screen sizes. Our mobile-first approach ensures that your customers enjoy a seamless shopping experience whether they're on a phone, tablet, or desktop. If you're looking for an ecommerce site that performs perfectly across devices, our responsive design service is the answer.</p>
        </div>
      </div>
    </div>

  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Ecommerce;